<template>
  <div class="social-icons">
    <v-btn icon class="light-blue--text"
      :href="'https://twitter.com/home?status=http%3A//recallfind.com/recall/' + this.id"
      aria-label="Twitter link"
    >
      <v-icon small>fab fa-twitter</v-icon>
    </v-btn>
    <v-btn icon class="blue--text text--darken-4"
      :href="'https://www.facebook.com/sharer/sharer.php?u=http%3A//recallfind.com/recall/' + this.id"
      aria-label="Facebook link"
    >
      <v-icon small>fab fa-facebook-f</v-icon>
    </v-btn>
    <v-btn icon class="red--text"
      :href="'http://reddit.com/submit?url=http%3A//recallfind.com/recall/' + this.id + '&title=' + encodeURL(this.title)"
      aria-label="Reddit link"
    >
      <v-icon small>fab fa-reddit</v-icon>
    </v-btn>
    <v-btn icon class="blue--text text--darken-4"
      :href="'https://www.linkedin.com/shareArticle?mini=true&url=http%3A//recallfind.com/recall/' + this.id + '&title=' + encodeURL(this.title) + '&summary=&source='"
      aria-label="LinkedIn link"
    >
      <v-icon small>fab fa-linkedin-in</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'Social',
  props: ['id', 'title'],
  methods: {
    encodeURL (inputText) {
      return encodeURI(inputText)
    }
  }
}
</script>
